const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Servicio centralizado de API que maneja autenticación y errores 401
 */
class ApiService {
  constructor() {
    this.onUnauthorized = null;
  }

  setOnUnauthorized(callback) {
    this.onUnauthorized = callback;
  }

  getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  async handleResponse(response) {
    let data;
    try {
      data = await response.json();
    } catch {
      const texto = await response.text();
      throw new Error(texto || `Error del servidor (${response.status})`);
    }

    // Si la respuesta es 401 (no autorizado), ejecutar callback y limpiar sesión
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      if (this.onUnauthorized) {
        this.onUnauthorized();
      }

      throw new Error('Sesión expirada. Por favor, vuelve a iniciar sesión.');
    }

    if (!response.ok) {
      const mensajesPermitidos = [
        'Credenciales inválidas',
        'No autorizado',
        'Sesión inválida o expirada',
        'No tienes permisos para realizar esta acción',
        'No tienes el rol necesario para esta acción',
        'Demasiadas solicitudes, intenta de nuevo más tarde',
      ];
      const mensaje = mensajesPermitidos.includes(data.error)
        ? data.error
        : 'Error en la solicitud';
      throw new Error(mensaje);
    }

    return data;
  }

  async get(endpoint) {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'GET',
      headers: this.getAuthHeaders()
    });
    return this.handleResponse(response);
  }

  async post(endpoint, body) {
    const headers = this.getAuthHeaders();

    // Si body es FormData, no setear Content-Type (el navegador lo hará automáticamente)
    const isFormData = body instanceof FormData;
    if (isFormData) {
      delete headers['Content-Type'];
    }

    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers,
      body: isFormData ? body : JSON.stringify(body)
    });
    return this.handleResponse(response);
  }

  async put(endpoint, body) {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'PUT',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(body)
    });
    return this.handleResponse(response);
  }

  async delete(endpoint) {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'DELETE',
      headers: this.getAuthHeaders()
    });
    return this.handleResponse(response);
  }
}

export default new ApiService();
